import { createSlice } from "@reduxjs/toolkit";

const initialVendorsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  vendorForEdit: undefined,
  lastError: null
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const vendorsSlice = createSlice({
  name: "vendors",
  initialState: initialVendorsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getVendorById
    vendorFetched: (state, action) => {
      state.actionsLoading = false;
      state.vendorForEdit = action.payload.vendorForEdit;
      state.error = null;
    },
    // findVendors
    vendorsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    }
  }
});